import { rucksack, theme } from '@black-bear-energy/rucksack'

/** localStorage key for the cached nav visibility flags. */
export const NAV_VISIBILITY_KEY = 'nav-visibility'

/** Shared transition config for nav expand/collapse animations. */
export const NAV_TRANSITION = {
  duration: theme.transitions.duration.standard,
  easing: theme.transitions.easing.easeInOut,
} as const

/** Width of the side navigation when fully expanded, in pixels. */
export const NAV_WIDTH_EXPANDED = 256
/** Width of the side navigation when collapsed to icons only, in pixels. */
export const NAV_WIDTH_COLLAPSED = 64
/** Height of the top header bar, in pixels. */
export const HEADER_HEIGHT = 64

const interactiveColor = rucksack.palette.primary.dark

const navItemInteractiveStyles = {
  color: interactiveColor,
  '& .MuiListItemIcon-root': { color: 'inherit' },
} as const

/**
 * MUI `sx` styles applied to a nav item on hover or focus,
 * and to a sub item when selected (matches the current route).
 * */
export const NAV_ITEM_HOVER_STYLES = {
  backgroundColor: rucksack.palette.primary.states.hover,
  ...navItemInteractiveStyles,
} as const

/** MUI `sx` styles applied to a top-level nav item when selected (matches the current route). */
export const NAV_ITEM_ACTIVE_STYLES = {
  backgroundColor: rucksack.palette.primary.states.selected,
  ...navItemInteractiveStyles,
} as const

/** Base MUI `sx` styles shared by all nav items, including default hover styles. */
export const NAV_ITEM_BASE_SX = {
  borderRadius: rucksack.shape.borderRadius,
  color: rucksack.palette.text.primary,
  textDecoration: 'none',
  '&:hover, &:focus-visible': NAV_ITEM_HOVER_STYLES,
} as const
